<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 动态按钮生成 -->
		<div class="content_edit">
			<pre-btn-Excel @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
					<button class="pre_btn_ok" v-show="show_step_btn" @click="fun_show_step">审核流程</button>
				</div>
			</div>
		</div>
		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<div v-if="item.type == 'text'">
					<label>{{item.name}}:</label>
					<input type="text" :class="[item.class==''?'long1':item.class]" v-model="item.val"
						:placeholder="item.note" @keyup.enter="refresh_data" />
				</div>
				<div v-else-if="item.type == 'select'" :id="item.slot">
					<label>{{item.name}}:</label><input type="text" :class="[item.class==''?'short0':item.class]"
						v-model="item.sel_name" @change="select_change(item.key,item.sel_name,item.list)" />
					<pre-sel-one :class="[item.class==''?'short':item.class]"
						@selectFunc="fun_list_sel('sel',item.key,item.list,$event)" v-bind:searchList="item.list"
						:selectValue="item.sel_val" />
				</div>
				<div v-else-if="item.type == 'date'">
					<label>{{item.name}}:</label>
					<el-date-picker v-model="item.val" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>
				</div>
				<div v-else-if="item.type == 'radio'">
					<el-radio-group v-model="radio" size="mini" @change="fun_option('sel',item)">
						<el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id" border>
							{{d.name}}
						</el-radio>
					</el-radio-group>
				</div>
			</div>
			<!-- <div class="content_edit_item" v-show="file_show && show_FileMain">
				<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
			</div> -->
		</div>

		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm" :api_url="sel_action"
			:api_action="upd_action" />

		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header_new" :class="[isTwo=='1'?TwoNone:'']">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index" :class="[t.class!=''?t.class:'tab_w']">
						<div v-if="t.name=='全选'">
							<button @click="check_sel_all(is_all)">全选</button>
						</div>
						<div v-else>{{t.name}}</div>
					</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[1].val"  :class="[isTwo=='1'?TwoNone:'']" @click="sel_row(user.item,'all')"
					@dblclick="edit_data">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='to_check'">
							<input type="checkbox" v-model="d.val" />
						</div>
						<div v-else>{{d.val}}</div>
					</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr>
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 弹窗编辑 start -->
		<div v-show="show_tan" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_tan_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">
					<div class="pre_leve_one">
						<h3 class="cen">{{title}}</h3>
						<!-- 操作按钮生成 -->
						<div class="content_edit">
							<div class="content_edit_item" v-show="show_btn">
								<pre-button @button-event="select_method" :pre_control="control" />
								<div class="content_btn">
									<div class="content_btn_item">
										<button class="pre_btn_ok" v-show="show_step_btn"
											@click="fun_show_step">审核流程</button>
									</div>
								</div>
							</div>
							<!-- <div class="content_edit_item" v-show="sheet_flag!=''?true:false">
								<h3 class="red">
									{{sheet_flag}}
								</h3>
							</div> -->
						</div>
						<!-- 这里放主单据编辑内容-->
						<div class="content_edit">
							<div class="content_edit_item" v-for="(item,index) in parm" :key="index">
								<div v-if="item.type == 'text'">
									<label>{{item.name}}:</label>
									<input type="text" :class="[item.class==''?'short0':item.class]" v-model="item.val"
										:placeholder="item.note" @keyup.enter="select_method('add')" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'number'">
									<label>{{item.name}}:</label><input type="number"
										:class="[item.class==''?'short0':item.class]" v-model="item.val"
										@keyup.enter="select_method('add')" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'date'">
									<label>{{item.name}}:</label>
									<el-date-picker v-model="item.val" type="date"
										:class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
										placeholder="选择日期">
									</el-date-picker>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'select'" :id="item.slot">
									<label>{{item.name}}:</label><input type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.sel_name"
										@change="select_change_main(item.key,item.sel_name,item.list)" />
									<pre-sel-one :class="[item.class==''?'short':item.class]"
										@selectFunc="fun_list_sel('main',item.key,item.list,$event)"
										v-bind:searchList="item.list" :selectValue="item.sel_val"
										:selectRandom="sel_Random" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'time'">
									<label>{{item.name}}:</label>
									<el-time-picker v-model="item.val" format="HH:mm:ss" :picker-options="{
                        selectableRange: '06:30:00 - 23:59:59'
                      }" placeholder="任意时间点">
									</el-time-picker>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'none'">
									<input type="text" v-show="false" v-model="item.val" />
								</div>
								<div v-else-if="item.type == 'readonly'">
									<label>{{item.name}}:</label><input class="input_readonly" type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.val"
										readonly="readonly" />
								</div>
								<div v-else-if="item.type == 'radio'">
									<el-radio-group v-model="radio" size="mini" @change="fun_option('main',item)">
										<el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id" border>
											{{d.name}}
										</el-radio>
									</el-radio-group>
								</div>
								<div v-else-if="item.type == 'checkbox'">
									<label>{{item.name}}:</label>
									<el-checkbox :indeterminate="isIndeterminate" v-model="item.check_all"
										@change="handleCheckAllChange(item.key,item.list,$event)">全选
									</el-checkbox>
									<!-- <div style="margin: 15px 0;"></div> -->
									<el-checkbox-group class="checkbox_group" v-model="item.checked_list"
										@change="handleCheckedChange(item.key,item.list,$event)">
										<el-checkbox v-for="d in item.list" :label="d.val" :key="d.id">{{d.val}}
										</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>

							<div class="content_edit_item" v-show="file_show && show_FileMain">
								<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
							</div>
						</div>
					</div>

					<div v-show="show_d" class="pre_leve_two">


						<!-- 这里放明细单据内容 -->
						<h5 class="cen pretop">{{title}}明细</h5>

						<!-- 明细部分编辑区 -->
						<div class="content_edit">
							<div v-show="show_d_edit" class="content_btn_row">
								<div class="content_btn">
									<div class="content_btn_item">
										<button class="pre_btn_ok" @click="fun_d_load()">
											查询
										</button>
										<button class="pre_btn_ok" @click="d_data_clear()">
											清空
										</button>
										<button class="pre_btn_ok" @click="fun_d_save('_add')">
											增加
										</button>
										<button class="pre_btn_ok" @click="fun_d_save('_upd')">
											修改
										</button>
									</div>
								</div>
							</div>

							<div class="content_edit_item" v-for="(item,index) in d_parm" :key="index">
								<div v-if="item.type == 'text'">
									<label>{{item.name}}:</label>
									<input :id="[item.first=='isfirst'?'isfirst':'no'+GetRandom()]" type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.val"
										@keyup.enter="go_first" />
									<em v-show="item.weight=='1'">*</em>
									<em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'number'">
									<label>{{item.name}}:</label>
									<input type="number" :class="[item.class==''?'short0':item.class]"
										v-model="item.val" @keyup.enter="go_first" />
									<em v-show="item.weight=='1'">*</em>
									<em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'date'">
									<label>{{item.name}}:</label>
									<el-date-picker v-model="item.val" type="date"
										:class="[item.class==''?'short0':item.class]" value-format="yyyy-MM-dd"
										placeholder="选择日期">
									</el-date-picker>
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'select'" :id="item.slot">
									<label>{{item.name}}:</label>
									<input type="text" :class="[item.class==''?'short0':item.class]"
										v-model="item.sel_name"
										@change="select_change_child(item.key,item.sel_name,item.list)" />
									<pre-sel-one :class="[item.class==''?'short':item.class]"
										@selectFunc="fun_list_sel('children',item.key,item.list,$event)"
										v-bind:searchList="item.list" :selectValue="item.sel_val" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>
								<div v-else-if="item.type == 'none'">
									<input type="text" v-show="false" v-model="item.val" />
								</div>
								<div v-else-if="item.type == 'readonly'">
									<label>{{item.name}}:</label>
									<input class="input_readonly" type="text"
										:class="[item.class==''?'short0':item.class]" v-model="item.val"
										readonly="readonly" />
								</div>
								<div v-else-if="item.type == 'radio'">
									<el-radio-group v-model="d_radio" size="mini" @change="fun_option_d(item,d.id)">
										<el-radio v-for="(d,d_index) in item.name" :key="d_index" :label="d.id" border>
											{{d.name}}</el-radio>
									</el-radio-group>
								</div>
								<!-- add 2021-05-22 swich 支持新增 start-->
								<div v-else-if="item.type == 'switch'">
									<el-switch v-model="show_in" active-color="#13ce66" inactive-color="#ff4949">
									</el-switch>
									<label v-show="show_in">{{item.name_in}}:</label>
									<label v-show="show_out">{{item.name_out}}:</label>
									<input type="text" :class="[item.class==''?'short0':item.class]"
										v-model="item.sel_name" @keyup.enter="fun_list_sel_change(item.key)" />
									<pre-sel-one class="short"
										@selectFunc="fun_list_sel('children',item.key,item.list_in,$event,'i')"
										v-bind:searchList="item.list_in" :selectValue="item.sel_val_in"
										v-show="show_in" />
									<pre-sel-one class="short"
										@selectFunc="fun_list_sel('children',item.key,item.list_out,$event,'o')"
										v-bind:searchList="item.list_out" :selectValue="item.sel_val_out"
										v-show="show_out" />
									<em v-show="item.weight=='1'">*</em><em v-show="item.weight==''"></em>
								</div>


							</div>
							<div class="content_edit_item" v-show="file_show && show_FileChildren">
								<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
							</div>
						</div>
						<!-- 明细部分展示区 -->
						<div id="pre_tab" class="pre_tab">
							<table class="pre_table_detail_new" border="1" cellpadding="2" cellspacing="1">
								<tr class="tab_header_new" :class="[isTwoDetail=='1'?TwoNone:'']">
									<td v-for="(t,index) in d_name" :key="index">{{t.name}}</td>
									<td>操作</td>
								</tr>
								<tr :id="'d_'+data_tr[0].val" :class="[isTwoDetail=='1'?TwoNone:'']"
									v-for="data_tr in d_detail" @click="fun_d_upd(data_tr)">
									<!-- <a href="#"> -->
									<td v-for="(d,index) in data_tr" :key="index"
										v-on:mousemove="show_detaildata($event, d.val, '1')"
										v-on:mouseout="noshow_detaildata">
										<!-- <a href="#">{{d.val}}</a> -->
										{{d.val}}
									</td>
									<!-- </a> -->
									<td>
										<span v-show="show_d_edit" @click="fun_d_edit('_upd',data_tr)">
											<i class="iconfont icon-bianji"></i>修改
										</span>
										<span v-show="show_d_edit" @click="fun_d_del('_del',data_tr)">
											<i class="iconfont icon-shanchu"></i>删除
										</span>
									</td>
								</tr>
							</table>
						</div>

					</div>

					<!-- 弹出向导层 end-->
				</div>
			</div>

		</div>

		<!-- 弹窗编辑 end -->

		<pre-step :pre_show_tan="show_step" :pre_data="show_stepdata" />

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_DataByPage,
		Method_Common,
		Method_EasySelect,
		Method_CommonLong
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	export default {
		name: "pre_base_table_new",
		components: {
			"pre-button": () => import("./pre_btn_control_tan.vue"),
			"pre-btn-Excel": () => import("./pre_btn_control_Excel.vue"),
			"pre-table": () => import("./pre_table_nokey_20210512.vue"),
			// "pre-table": () => import("../personmode/pre_table_nokey2.vue"),
			'per-exceldown': () => import("./pre_excel_down.vue"),
			'per-excelup': () => import("./pre_excel_up_new.vue"),
			'pre-sel-one': () => import("./pre_select_one.vue"),
			"pre-step": () => import("./pre_base_tan_step.vue")
		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				bak_data: '', //防止重复操作记录
				nowpage: '1',
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				action_flag: '', //切换传参长度默认15个，long 30个
				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				d_radio: '1',
				// 弹窗编辑
				show_tan: false,

				// 明细部分参数
				show_d: false,
				show_d_edit: true,
				d_load_url: '',
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				// 备注
				detail_data: '',
				//文件
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',
				// swich 开关
				show_in: true,
				show_out: false,

				// 自定义组件 流程
				show_step: '0',
				show_stepdata: '',
				pass_step: "1",
				show_step_btn: false,
				// checkbox 组件
				isIndeterminate: true,

				// 定义默认样式
				isTwo: '1',
				isTwoDetail: '1',
				TwoNone: 'last-two-none',
				DTwoNone: "dlast-two-none",
				// 主单据附件判断
				isFileMain: 0,
				show_FileMain: false,
				show_FileChildren: true,

				// 下拉菜单
				sel_Random: '',

				// 路径变化
				new_key: '',

				// 多选内容
				list_check: [],
				is_all: false,

			};
		},
		props: {
			pre_data: {
				type: String,
				default: ''
			}
		},
		watch: {
			pre_data(val) {
				if (val.length > 0) {
					this.load_data();
				}
			},
			d_sel_action(val) {
				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.show_d = true;
				} else {
					this.show_d = false;
				}
			},
			sheet_flag(val) {
				if (val == '已提交') {
					// this.show_btn = false;
					this.show_d_edit = false;
				} else {
					// this.show_btn = true;
					this.show_d_edit = true;
				}
			},
			show_in(val) {
				//console.log('==' + val);
				if (val) {
					this.show_out = false;
				} else {
					this.show_out = true;
				}
			},
			pass_step(val) {
				//console.log('==' + val);
				if (val == '1') {
					this.show_step_btn = false;
				} else {
					this.show_step_btn = true;
				}
			},
			isFileMain(val) {
				if (val == '1') {
					this.show_FileMain = true;
					this.show_FileChildren = false;
				} else {
					this.show_FileMain = false;
					this.show_FileChildren = true;
				}
			}

		},
		mounted: function() {
			if (this.pre_data != '') {
				let that = this;
				this.$nextTick(function() {
					that.load_data();
				});
			}
		},
		methods: {
			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			check_sel_all: function() {
				this.is_all = this.is_all ? false : true;

				console.log('isAll=' + this.is_all);
				// 通过自组件 获取当前 list ,

			},
			check_val: function(e, val, item) {
				console.log(e);
				console.log('val=' + val);
				console.log('元素:', item);

				if (val == '1') {
					return true;
				} else {
					return false;
				}
			},
			fun_show_step: function() {
				console.log('sheet_no=' + this.sheet_no);

				if (typeof(this.sheet_no) == "undefined" || this.sheet_no == '') {
					this.$message({
						message: '请选择要操作的单据信息!',
						type: 'warning'
					});
					return
				}

				this.show_stepdata = '';
				this.show_stepdata = JSON.stringify({
					"title": this.title + '流程',
					"sheet_no": this.sheet_no,
					"sel_action": 'exp_step'
				});
				this.show_step = (Math.random() + '').substring(0, 8);

			},
			show_edit: function() {
				//console.log('弹窗。。。。。');
				if (this.show_tan) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_tan_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_tan_bg").fadeIn("3000");
					$(".pre_tan_conten").fadeIn("3000");

				} else {
					this.closeshow();
				}
			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");
				this.show_tan = false;

				// 关闭窗口 应该更新编辑信息？=》如果发生编辑 =》才应该进行更新
				// 保证 编辑后清空 全部查询
				// for (let i = 0; i < this.parm_sel.length; i++) {
				//   this.parm_sel[i].val = '';
				// }

				this.load_db_data();
				// this.$emit('base2-event', 'father');
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {
				// //console.log(this.pre_data);

				// await this.data_clear();
				// await this.d_data_clear();
				let r = JSON.parse(this.pre_data);
				//console.log(r);
				let that = this;
				this.$nextTick(function() {
					that.title = r.title;
					that.control = r.control;
					that.pass_step = r.step;

					that.sel_action = r.sel_action;
					that.upd_action = r.upd_action;
					that.d_sel_action = r.d_sel_action;
					that.d_upd_action = r.d_upd_action;

					that.file_action = r.file_action;
					that.isFileMain = r.isFileMain;
					that.p1 = r.p1;
					that.p2 = r.p2;
					that.p3 = r.p3;
					that.parm_sel = r.parm_sel;
					that.parm = r.parm;
					that.parm_th = r.parm_th;

					that.d_parm = r.d_parm;
					that.d_name = r.d_name;
					that.d_detail = [];

					if (typeof(r.action_flag) != "undefined" && r.action_flag != '') {
						that.action_flag = r.action_flag;
					}

					if (typeof(r.isTwo) != "undefined" && r.isTwo != '') {
						that.isTwo = r.isTwo;
					}
					if (typeof(r.isTwoDetail) != "undefined" && r.isTwoDetail != '') {
						that.isTwoDetail = r.isTwoDetail;
					}

					//依据 配置参数 加载刷新当前数据。
					that.load_db_data();
				});
			},
			select_method: function(type) {
				//console.log('操作=' + type);
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				//console.log('全条件查询====');
				//console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					switch (this.parm_sel[i].sel) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
					}
				}

				// 通过链接解析
				let t_url = '';
				t_url = window.location.href;
				if (typeof(t_url) !== 'undefined' && t_url != '') {
					t_url = t_url.substring(t_url.lastIndexOf('&'));
					if (t_url.indexOf('key=') > 0) {
						let a = t_url.split('=')[1];
						this.kw1 = a
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Method_DataByPage('data_' + that.sel_action, that.nowpage, that.kw1, that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, r);
				}, 200);
			},
			load_push_data: function() {
				console.log('筛选====');
				//console.log(this.parm_sel);

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Method_DataByPage('data_' + that.sel_action, that.nowpage, that.kw1, '',
						'', '', '',
						'', '', '', '', r);
				}, 200);
			},
			refresh_data: function(type, page, backdata) {
				console.log('查询刷新=' + type + ' page=' + page);

				let r = (Math.random() + '').substring(0, 8);
				if (Number(page) > 0) {
					this.nowpage = page;
					// 更新编辑信息
					this.load_db_data();
				}
				// console.log(backdata);
				let back = null;
				if (typeof(backdata) != "undefined" && backdata != '') {
					back = JSON.parse(backdata);
					//console.log(back);
					// //console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					// 同步关键参数便于后续修改
					this.sheet_flag = back.msg;
					this.sheet_no = back.keyword.sheet_no;
				}

				if (this.sheet_flag.indexOf('提交成功') >= 0) {
					this.show_btn = false;

				} else {
					this.show_btn = true;
				}

				if (this.sheet_flag.indexOf('删除成功') == 0) {
					this.closeshow();
				}

				console.log('sheet_no=' + this.sheet_no);
				if (typeof(this.sheet_no) != "undefined" && this.sheet_no != '') {
					this.element_loading = true;
					this.$post(
						api.http_method, Method_DataByPage('data_' + this.sel_action, 1, this.sheet_no,
							'', '', '', '', '', '', '', '', '', '', '', '',
							r)
					).then(res => {
						res = JSON.parse(res);
						//console.log(res.data);

						if (Number.parseInt(res.data.status) == 1) {
							let bd = [];
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// //console.log('key=' + j);       //输出key
									// //console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								bd.push(arr);
							}

							this.sel_row(bd[0], 'edit');

							



						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}
						this.element_loading = false;
					});

					return;
				}




			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			new_blank: async function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;
				this.d_detail = [];
				await this.data_clear();
				this.show_edit();
			},
			edit_data: function() {
				this.show_tan = true;
				// 双击打开界面,如果有明细,应该查询
				//console.log(this.d_upd_action);
				if (typeof(this.d_sel_action) != 'undefined' && this.d_sel_action != '') {
					this.fun_d_load();
				}
				this.show_edit();
			},
			sel_row: function(item, type) {
				// console.log(item);
				//console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				this.data_clear();
				this.d_data_clear();

				this.sel_Random = Math.random() + '';

				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							if (this.sheet_flag == '盘点完成') {
								this.show_btn = false;
								this.show_btn_ok = true;
							} else {
								this.show_btn = true;
								this.show_btn_ok = false;
							}
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (item[i].key == this.parm[j].key) {
							if (this.parm[j].type == 'radio') {
								// if (item[i].val == '是') {
								//   this.radio = '1';
								// } else {
								//   this.radio = '0';
								// }
								// //console.log(this.parm[j]);
								// //console.log(item[i].val);
								for (let k = 0; k < this.parm[j].name.length; k++) {
									// //console.log(' id='+this.parm[j].name[k].id+' name='+this.parm[j].name[k].name + ' = ' + item[i].val);
									if (this.parm[j].name[k].name == item[i].val) {
										this.parm[j].val = this.parm[j].name[k].id;
										this.radio = this.parm[j].name[k].id;
										break;
									}
								}
							} else if (this.parm[j].type == 'select') {
								let tlist = this.parm[j].list;
								for (let m = 0; m < tlist.length; m++) {
									if (tlist[m].val == item[i].val) {
										this.parm[j].val = tlist[m].id;
										this.parm[j].sel_name = tlist[m].val;
										// console.log('选择 ID='+tlist[m].id+' val='+tlist[m].val)
										break;
									}
								}

							} else if (this.parm[j].type == 'checkbox') {
								//console.log(item[i].val);
								this.parm[j].checked_list = item[i].val.split(',');
								this.parm[j].val = item[i].val.split(',');

							} else if (this.parm[j].type == 'sheet_no') {
								this.parm[j].val = item[i].val;
							} else {
								if (this.parm[j].key == item[i].key) {
									this.parm[j].val = item[i].val;
									break;
								}
							}

						}

					}
				}

				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item);
				// 切换背景色
				if (type != 'edit') {
					this.$refs.file_table.setCurrentRowJson('m_', item[1].val);
				}
				
				if (type=='edit' && typeof(this.d_sel_action) != 'undefined' && this.d_sel_action != '') {
					this.fun_d_load();
				}



			},
			fun_option: function(type, item) {
				//console.log(item);

				//console.log('type=' + type + ' radio=' + this.radio);
				// 单选项 参数传值。
				if (type == 'sel') {
					for (let j = 0; j < this.parm_sel.length; j++) {
						if (this.parm_sel[j].type == 'radio' && this.parm_sel[j].key == item.key) {
							this.parm_sel[j].val = item.name[this.radio - 1].val;
							//console.log('id=' + this.radio + '  val=' + item.name[this.radio - 1].val);
							break;
						}
					}
					this.load_db_data();
				}

				if (type == 'main') {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].type == 'radio' && this.parm[j].key == item.key) {
							this.parm[j].val = item.name[this.radio - 1].val;
							//console.log('id=' + this.radio + '  val=' + this.parm[j].val);
							break;
						}
					}
				}
			},
			data_clear: function() {
				// //console.log('清除 历史 参数。。。。');
				this.bak_data = ''; //防止重复操作记录

				this.row_id = '';
				this.sel_item = {}; //备份点击项目
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (typeof(this.parm[j].type) != 'undefined' && this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else if (typeof(this.parm[j].type) != 'undefined' && this.parm[j].type == 'checkbox') {
						this.parm[j].val = '';
						this.parm[j].checked_list = [];

					} else if (typeof(this.parm[j].type) != 'undefined' && this.parm[j].type == 'fixed') {


					} else {
						this.parm[j].val = '';
					}

				}

				// for (let j = 0; j < this.parm_sel.length; j++) {
				// 	if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
				// 		this.parm_sel[j].val = '';
				// 		this.parm_sel[j].sel_name = '';
				// 		this.parm_sel[j].sel_val = {};
				// 	} else if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'fixed') {

				// 	} else {
				// 		this.parm_sel[j].val = '';
				// 	}

				// }

				// //console.log('===END============')
			},
			fun_upd: function(type) {
				// //console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}


				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// //console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].weight == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// //console.log(this.parm[i].val);
					if (this.parm[i].p)
						d.push(this.parm[i].val);
				}


				let r = (Math.random() + '').substring(0, 8);

				if (this.action_flag == 'long') {
					this.upd_json = Method_CommonLong('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
						r);
				} else {
					this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d, r);
				}

			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// //console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// //console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 400px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			select_change: function(key, val, list) {

				let t_list = [];
				let t_flag = true;
				let t_main = true;

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (this.parm_sel[j].key == key &&
						(typeof(this.parm_sel[j].list_bak) == "undefined" || this.parm_sel[j].list_bak.length == 0)) {
						// //console.log('首次备份结果');
						this.parm_sel[j].list_bak = [];
						this.parm_sel[j].list_bak = list;
						// //console.log(this.parm_sel[j].list_bak);
						break;
					}
				}

				// 模糊查询
				if (typeof(val) != "undefined" && val != '') {

					// 模糊查询
					for (let j = 0; j < this.parm_sel.length; j++) {
						if (this.parm_sel[j].key == key) {
							this.parm_sel[j].list = [];
							for (var i = 0; i < this.parm_sel[j].list_bak.length; i++) {
								if (this.parm_sel[j].list_bak[i].val.indexOf(val) >= 0) {
									this.parm_sel[j].list.push(this.parm_sel[j].list_bak[i]);
								}
							}
						}
					}

				} else {
					for (let j = 0; j < this.parm_sel.length; j++) {
						if (this.parm_sel[j].key == key) {
							t_list = this.parm_sel[j].list_bak;
							this.parm_sel[j].list = t_list;
							break;
						}
					}
				}



			},
			select_change_main: function(key, val, list) {
				// //console.log('key=' + key);
				// //console.log('val=' + val);

				let t_list = [];
				let t_flag = true;
				let t_main = true;

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].key == key &&
						(typeof(this.parm[j].list_bak) == "undefined" || this.parm[j].list_bak.length == 0)) {
						// console.log('首次备份结果');
						this.parm[j].list_bak = [];
						this.parm[j].list_bak = list;
						break;
					}
				}

				// 模糊查询
				if (typeof(val) != "undefined" && val != '') {

					// 模糊查询
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == key) {
							this.parm[j].list = [];
							for (var i = 0; i < this.parm[j].list_bak.length; i++) {
								if (this.parm[j].list_bak[i].val.indexOf(val) >= 0) {
									this.parm[j].list.push(this.parm[j].list_bak[i]);
								}
							}
						}
					}

				} else {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == key) {
							t_list = this.parm[j].list_bak;
							this.parm[j].list = t_list;
							break;
						}
					}
				}


			},
			select_change_child: function(key, val, list) {

				let t_list = [];
				let t_flag = true;
				let t_main = true;

				// 备份数据
				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].key == key &&
						(typeof(this.d_parm[j].list_bak) == "undefined" || this.d_parm[j].list_bak.length == 0)) {
						// //console.log('首次备份结果');
						this.d_parm[j].list_bak = [];
						this.d_parm[j].list_bak = list;
						break;
					}
				}

				// 模糊查询
				if (typeof(val) != "undefined" && val != '') {

					// 模糊查询
					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].key == key) {
							this.d_parm[j].list = [];
							for (var i = 0; i < this.d_parm[j].list_bak.length; i++) {
								if (this.d_parm[j].list_bak[i].val.indexOf(val) >= 0) {
									this.d_parm[j].list.push(this.d_parm[j].list_bak[i]);
								}
							}
						}
					}

				} else {
					for (let j = 0; j < this.d_parm.length; j++) {
						if (this.d_parm[j].key == key) {
							t_list = this.d_parm[j].list_bak;
							this.d_parm[j].list = t_list;
							break;
						}
					}
				}


			},

			fun_list_sel: async function(type, key, list, id, io) {
				// console.log('type=' + type);

				// console.log(key);

				// console.log(list);

				switch (type) {
					case 'sel':
						for (let j = 0; j < this.parm_sel.length; j++) {
							if (this.parm_sel[j].key == key) {
								for (let i = 0; i < list.length; i++) {
									if (list[i].id == id) {
										this.parm_sel[j].sel_name = list[i].val;
										this.parm_sel[j].val = list[i].id;

										let sel_more = '';
										sel_more = this.parm_sel[j].sel_more;
										// console.log('查询sel_more=' + sel_more)
										if (typeof(sel_more) !== 'undefined' && sel_more != '' && sel_more.indexOf(
												'_to') > 0) {
											console.log(' index=' + sel_more.indexOf('_to'));
											let t_sel = sel_more.substring(0, 1); //第一位 作为关联 关键字

											console.log('开始联动查询 关键字=' + t_sel);

											for (let k = 0; k < this.parm_sel.length; k++) {
												if (this.parm_sel[k].sel_more == t_sel &&
													typeof(this.parm_sel[k].sel_action) !== 'undefined' &&
													this.parm_sel[k].sel_action !== '') {
													console.log('有关联 字符' + this.parm_sel[k].name);

													let res = await this.fun_load_class(this.parm_sel[k].sel_action,
														list[i].id);
													if (res.status != '1') {
														this.parm_sel[k].list = [];
														this.$message({
															type: 'info',
															message: '联动查询失败,原因:' + res.msg
														});
														return;
													}
													// console.log(res);
													let t = res.data;
													this.parm_sel[k].list = t;
												}
											}
										}

										break;
									}
								}
								break;
							}
						}
						// this.refresh_data(); //查询下拉菜单变更后自动查询
						break;
					case 'main':

						for (let j = 0; j < this.parm.length; j++) {
							if (this.parm[j].key == key) {
								for (let i = 0; i < list.length; i++) {
									if (list[i].id == id) {
										this.parm[j].sel_name = list[i].val;
										this.parm[j].val = list[i].id;

										let sel_more = '';
										sel_more = this.parm[j].sel_more;
										console.log('sel_more=' + sel_more);
										if (typeof(sel_more) !== 'undefined' && sel_more != '' && sel_more.indexOf(
												'_to') > 0) {
											let t_sel = sel_more.substring(0, 1); //第一位 作为关联 关键字

											for (let k = 0; k < this.parm.length; k++) {
												if (this.parm[k].sel_more === t_sel &&
													typeof(this.parm[k].sel_action) !== 'undefined' &&
													this.parm[k].sel_action !== '') {
													// console.log('有关联 字符');

													let res = await this.fun_load_class(this.parm[k].sel_action, list[
														i].id);
													if (res.status != '1') {
														this.$message({
															type: 'info',
															message: '联动查询失败,原因:' + res.msg
														});
														return;
													}
													// console.log(res);
													let t = res.data;
													this.parm[k].list = t;
												}
											}
										}

										break;
									}
								}
								break;
							}
						}
						break;
					case 'children':
						for (let j = 0; j < this.d_parm.length; j++) {
							if (this.d_parm[j].key == key) {
								for (let i = 0; i < list.length; i++) {
									if (list[i].id == id) {
										this.d_parm[j].sel_name = list[i].val;
										this.d_parm[j].val = list[i].id;
										break;
									}
								}
								break;
							}
						}

						if (typeof(io) != "undefined" && io != '') {
							for (let j = 0; j < this.d_parm.length; j++) {
								if (this.d_parm[j].key == 'io') {
									this.d_parm[j].val = io;
									break;
								}
							}
						}

						break;
					default:
						this.$message({
							message: 'ismain=' + type + ' 没有配置相关操作!',
							type: 'error'
						});
						break;
				}

				// let tlist = [];
				// tlist = e.target.dataset.set;
			},
			handleCheckAllChange: function(key, list, val) {
				//console.log(key)
				//console.log(list)
				//console.log(val)

				if (val) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].type == 'checkbox' && this.parm[j].key == key) {
							for (let i = 0; i < list.length; i++) {
								this.parm[j].checked_list.push(list[i].val);
							}

							this.parm[j].val = this.parm[j].checked_list.toString();
							break;
						}
					}
				} else {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].type == 'checkbox' && this.parm[j].key == key) {
							this.parm[j].checked_list = [];
							this.parm[j].val = '';
							break;
						}
					}
				}

				this.isIndeterminate = false;
			},
			handleCheckedChange: function(key, list, value) {
				// //console.log(key)
				// //console.log(list)
				// //console.log(value)

				let t = '';
				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'checkbox' && this.parm[j].key == key) {
						t = value.toString();
						this.parm[j].val = t;
						break;
					}
				}
				let checkedCount = value.length;
				// this.checkAll = checkedCount === this.cities.length;
				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'checkbox' && this.parm[j].key == key) {
						this.parm[j].check_all = checkedCount === list.length;
						this.isIndeterminate = checkedCount > 0 && checkedCount < list.length;
						break;
					}
				}

			},
			fun_load_class: function(action, p1, p2) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2)
					).then(res => {
						res = JSON.parse(res);
						resolve(res.data)
					});

				});
			},
			/****明细部分操作 start***********************************************/
			go_main: async function() {
				// 保存主数据
				let flag = false;
				flag = await this.check_parm();
				if (flag) {
					return;
				}
				this.fun_upd('_add');
			},
			go_first: function() {
				//console.log('回车移动光标');
				// 当按下回车时,将光标移走，避免与确认事件的回车 冲突。不起作用
				// document.getElementById('pre_displaynone').focus();
				// let flag = false;
				//
				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].key == 'sheet_no') {
						this.d_parm[j].val = this.sheet_no;
						break;
					}
				}

				this.fun_d_save('_add');
			},
			check_parm: function() {
				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.parm.length; i++) {
						if (that.parm[i].weight == '1' && that.parm[i].val == '') {
							that.$message({
								message: that.title + ': ' + that.parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},
			check_d_parm: function() {
				// //console.log('sheet_no333=' + this.sheet_no);
				if (this.sheet_no == null || this.sheet_no == '') {
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.sheet_no = this.parm[i].val;
							break;
						}
					}
				}

				// //console.log('sheet_no11111=' + this.sheet_no);

				let nosheet_no = true;
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no') {
						this.d_parm[i].val = this.sheet_no;
						nosheet_no = false;
						break;
					}
				}
				// //console.log('sheet_no222222='+this.sheet_no);
				//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
				if (nosheet_no) {
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'm_id') {
							this.d_parm[i].val = this.row_id;
							break;
						}
					}
				}

				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.d_parm.length; i++) {
						if (that.d_parm[i].weight == '1' && that.d_parm[i].val == '') {
							that.$message({
								message: that.title + '明细: ' + that.d_parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},
			d_data_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}
			},
			fun_d_upd: function(item) {
				// //console.log('编辑');
				// //console.log(item);
				this.d_data_clear();
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						case 'f_url':
							if(this.isFileMain!='1'){
								let tt = BackSpecial(item[i].val);
								tt = tt.substring(tt.lastIndexOf('/') + 1);
								this.file_name = tt;
								this.file_url = item[i].val;
								if (this.file_name != '') {
									this.file_show = true;
								} else {
									this.file_show = false;
								}
							}
							
							break;
						case 'f_src':
							if(this.isFileMain!='1'){
								this.file_src = item[i].val;
							}
							
							break;
						default:
							for (let j = 0; j < this.d_parm.length; j++) {
								if (this.d_parm[j].type == 'radio' && this.d_parm[j].key == item[i].key) {
									if (item[i].val == '是') {
										this.radio = '1';
									} else {
										this.radio = '0';
									}
									// //console.log(this.radio);
									this.d_parm[j].val = this.radio;
								} else if (this.d_parm[j].type == 'select' && this.d_parm[j].key == item[i].key) {

									for (let m = 0; m < this.d_parm[j].list.length; m++) {
										if (this.d_parm[j].list[m].val == item[i].val) {
											this.d_parm[j].val = this.d_parm[j].list[m].id;
											break;
										}
									}
									this.d_parm[j].sel_name = item[i].val;

								} else if (this.d_parm[j].type == 'switch' && this.d_parm[j].key == item[i].key) {
									// //console.log(item[i].val)
									// 写死了  支出 或者 收入
									this.d_parm[j].sel_name = item[i].val;
									this.d_parm[j].sel_val_in = {};
									this.d_parm[j].sel_val_out = {};
									// 自检
									for (let k = 0; k < item.length; k++) {
										if (item[k].val == '支出') {
											// //console.log(this.d_parm[j].list_in);
											for (let m = 0; m < this.d_parm[j].list_out.length; m++) {
												if (this.d_parm[j].list_out[m].val == item[i].val) {
													this.d_parm[j].val = this.d_parm[j].list_out[m].id;
													break;
												}
											}
										}

										if (item[k].val == '收入') {
											//console.log(this.d_parm[j].list_in);
											for (let m = 0; m < this.d_parm[j].list_in.length; m++) {
												if (this.d_parm[j].list_in[m].val == item[i].val) {
													this.d_parm[j].val = this.d_parm[j].list_in[m].id;
													break;
												}
											}
										}
									}
									// //console.log('val=' + this.d_parm[j].val);
								} else {
									if (this.d_parm[j].key == item[i].key) {
										this.d_parm[j].val = item[i].val;
										break;
									}
								}
							}
							break;
					}
				}

				// this.setActiveRowBackColor('d', item[0].val, 'detail');

			},
			fun_d_edit: function(type, item) {
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						default:
							break;
					}
				}
				this.fun_d_save(type);
			},
			fun_d_del: function(type, item) {
				let flag = true;
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.d_row_id = item[i].val;
							break;
						case 'sys_date':
							this.d_sys_date = item[i].val;
							break;
						case 'f_url':
							if (item[i].val != '') {
								flag = false;
							}
							break;
						default:
							break;
					}
				}
				if (flag) {
					this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.fun_d_save(type);
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});

				} else {
					this.$message({
						message: '请先删除附件,再删除数据!',
						type: 'warning'
					});
				}
			},
			fun_d_load: function() {
				// 加载明细数据
				// //console.log('加载明细数据=' + this.sheet_no);
				// //console.log(this.parm);
				this.d_detail = [];
				
				if (this.sheet_no == null || this.sheet_no == '') {
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.sheet_no = this.parm[i].val;
							break;
						}
					}
					// //console.log('sheet_no=' + this.sheet_no);
					let nosheet_no = true;
					for (let i = 0; i < this.d_parm.length; i++) {
						if (this.d_parm[i].key == 'sheet_no') {
							this.d_parm[i].val = this.sheet_no;
							nosheet_no = false;
							break;
						}
					}

					//	针对 没有单号 的明细 补充,默认 m_id 为主单ID add 2021-03-26
					if (nosheet_no) {
						for (let i = 0; i < this.d_parm.length; i++) {
							if (this.d_parm[i].key == 'm_id') {
								this.d_parm[i].val = this.row_id;
								this.sheet_no = this.row_id; //sheet_no 和  row_id 混和，不好这样，下次涉及注意优化
								break;
							}
						}
					}
				}

				

				if (this.sheet_no == null || this.sheet_no == '') {
					this.$message({
						message: '明细数据单号未匹配到,请刷新重试或联系开发人员!',
						type: 'warning'
					});
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Method_EasySelect('data_' + this.d_sel_action, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					try {
						res = JSON.parse(res);
						if (Number.parseInt(res.data.status) == 1) {
							this.maxpage = res.data.allpage;
							if (Number(res.data.allpage) == 0) {
								this.$message({
									message: '没有查询到数据',
									type: 'success'
								});
							} else {
								// //console.log(res.data.data);
								// this.data_tab = res.data.data;
								let t = res.data.data;
								for (let i = 0; i < t.length; i++) {
									let arr = [];
									for (let j in t[i]) {
										// //console.log('key=' + j);       //输出key
										// //console.log('val=' + t[i][j]); //输出key对应的value
										let o = {};
										o.key = j;
										o.val = t[i][j];
										arr.push(o);
									}
									this.d_detail.push(arr);
								}

								// 更新点击项目
								// //console.log('更新点击项目 d_row_id='+this.d_row_id);
								for (let i = 0; i < this.d_detail.length; i++) {
									// //console.log(this.d_detail[i]);
									for (let j = 0; j < this.d_detail[i].length; j++) {
										// //console.log('key='+this.d_detail[i][j].key+'  val='+this.d_detail[i][j].val);
										if (this.d_detail[i][j].key == 'id' && this.d_detail[i][j].val == this
											.d_row_id) {
											this.fun_d_upd(this.d_detail[i]);
											break;
										}
									}

								}
							}
						} else {
							this.$message({
								message: '明细 ' + res.data.msg,
								type: 'success'
							});
						}
					} catch (ex) {
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				});


			},
			fun_d_save: async function(type) {
				if (type == '_del') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let flag = false;
					flag = await this.check_d_parm();
					if (flag) {
						return;
					}
				}

				if (type == '_upd') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}



				let d = [];
				for (let i = 0; i < this.d_parm.length; i++) {
					// //console.log(this.parm[i].val);
					if (this.d_parm[i].p == '1') {

						d.push(this.d_parm[i].val);
					}
				}
				// //console.log('d_row_id=' + this.d_row_id);
				let temp_data = '';
				temp_data = Method_Common('data_' + this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						// //console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							// document.getElementById('isfirst').focus();
							let that = this;
							setTimeout(function() {
								that.refresh_data();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},
			fun_option_d: function(item, id) {
				// 单选项 参数传值。
				// //console.log(item);
				// //console.log('ID='+id);
				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type == 'radio' && this.d_parm[j].key == item.key) {
						this.d_parm[j].val = id;
						this.$emit('base2-event', 'changlist');
						break;
					}
				}
			},
			/****明细部分操作 end***********************************************/
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;
								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Method_DataByPage('data_' + this.sel_action, 99999999, this.kw1, this.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8)
					});

					this.show_excel = true;
				}
			},
			setActiveRowBackColor: function(key, id, type) {
				//console.log('key=' + key + ' id=' + id + ' type=' + type);
				key = key + '_';
				switch (type) {
					case 'detail':
						for (var i = 0; i < this.d_detail.length; i++) {
							// //console.log(this.d_detail[i]);
							if (this.d_detail[i][0].val == id) {
								document.getElementById(key + id).style.background = '#92a4f3';
							} else {
								if (this.d_detail[i][0].val % 2 == 0) {
									document.getElementById(key + this.d_detail[i][0].val).style.background = '#fff';
								} else {
									document.getElementById(key + this.d_detail[i][0].val).style.background =
									'#f5f5f5';
								}
							}
						}
						break;
					case 'main':
						break;
				}
			},
			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// //console.log('点击选择附件=' + this.row_id);
				if (this.isFileMain == '1') {
					if (this.row_id == null || Number(this.row_id) == 0) {
						this.$message({
							dangerouslyUseHTMLString: true,
							message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 项目名称ID=0</div>请检查!'
						});
						return;
					}
				} else {
					if (this.d_row_id == null || Number(this.d_row_id) == 0) {
						this.$message({
							dangerouslyUseHTMLString: true,
							message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 明细项目名称</div>请检查!'
						});
						return;
					}
				}

				// //console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				let fileobj = document.getElementById('hetong_file');
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();
			},
			fun_look_file: function() {
				//console.log('点击预览附件');
				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}
				//console.log(this.file_url);

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {


					// let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(BackSpecial(this.file_url));
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					let temp_src = BackSpecial(BackSpecial(this.file_src));
					let temp_type = temp_filename.substring(temp_filename.lastIndexOf('.') + 1);
					// //console.log(encodeURI(temp_url));
					// //console.log(encodeURI(temp_filename));
					// //console.log(temp_url);
					// //console.log(this.file_name);
					// down_file.download = encodeURI(this.file_name); // 下载名称
					// down_file.href = encodeURI(temp_url) ; // 绑定a标签
					// down_file.click(); // 模拟点击实现下载

					// var a = document.createElement('a');
					// a.download = temp_filename;
					// a.href = encodeURI(temp_url);
					// $("body").append(a);
					// a.click();
					// $(a).remove();

					let postdata = '';
					postdata =
						'{"file_src":"' + temp_src + '","file_name":"' + temp_filename + '"}';

					postdata = base_encode(postdata);
					let that = this;
					this.$get(
						api.http_downfile,
						postdata
					).then(res => {
						that.saveFile(res, temp_filename);
					});

					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});
				}
			},
			saveFile: function(data, fileName) {
				var export_blob = new Blob([data]);
				var save_link = document.createElement('a');
				document.body.appendChild(save_link);
				save_link.style.display = 'none';
				var urlObject = window.URL.createObjectURL(export_blob);
				save_link.href = urlObject;
				save_link.download = fileName;
				save_link.click();
				document.body.removeChild(save_link);
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// //console.log('点击选择结果');
				// //console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// //console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar|xls|xlsx)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar、xls、xlsx格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// //console.log(tmpFile);   //连标签原样输出了
					// //console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// //console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				//console.log('点击删除附件');
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two(this.file_src);
				// // 第二步 删除真实文件
				// this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function(temp_src) {
				var postdata = "";

				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + 'data_del_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","sheet_no":"' +
						this.sheet_no +
						'","rowid":"' +
						this.row_id +
						'"}';
				} else {
					postdata =
						'{"action":"' + 'data_del_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","sheet_no":"' +
						this.sheet_no +
						'","rowid":"' +
						this.d_row_id +
						'"}';
				}

				// //console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// //console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					this.fun_del_file_three(temp_src);
					if (this.isFileMain == '0') {
						that.fun_d_load();
					}
				});

			},
			fun_del_file_three: function() {
				// //console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// //console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// //console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
					// //console.log('小文件上传');
					this.fun_up_file_min();
				} else if (this.file_data.length > this.blockSize) {
					// //console.log('大文件上传');
					// this.element_loading = true;
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";

				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						// '","upfile_size":"' +
						// this.file_size +
						'","upfile_data":"' +
						this.file_data +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.sheet_no +
						'","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';
				} else {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						// '","upfile_size":"' +
						// this.file_size +
						'","upfile_data":"' +
						this.file_data +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.sheet_no +
						'","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';

				}

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						if (this.isFileMain == '0') {
							that.fun_d_load();
						}

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				// //console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// //console.log('上传长度=' + temp_data.size);
					// //console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						//console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						// '","upfile_size":"' +
						// this.file_size +
						'","upfile_data":"' +
						temp_filedata +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.sheet_no +
						'","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';
				} else {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						// '","upfile_size":"' +
						// this.file_size +
						'","upfile_data":"' +
						temp_filedata +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.sheet_no +
						'","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';

				}

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// //console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// //console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// //console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				//console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";


				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_path":"' +
						this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
						'","upfile_data":"' +
						'' +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.sheet_no +
						'"}';
				} else {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_path":"' +
						this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
						'","upfile_data":"' +
						'' +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.sheet_no +
						'"}';
				}

				// //console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.fun_d_load();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.pretop {
		margin-top: 5px;
	}

	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_table_detail_new {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_table_detail_new td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		/* max-width: 256px; */
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header_new td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
	}

	/* 首列是ID,不排序,隐藏 */
	.pre_table_detail_new tr td:nth-child(1) {
		display: none;
	}

	.pre_table_detail_new tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	.pre_table_detail_new tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_table_detail_new td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}


	.pre_table_detail_new td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_table_detail_new td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_table_detail_new tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_table_detail_new tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_table_detail_new tr:hover {
		background-color: #b8f8b8 !important;
	}

	/*  .pre_table_detail_new tr:focus {
    background: #92a4f3 !important;
  } */
	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		height: 100%;
		text-decoration: none;
		color: #333;
	}

	.pre_table_detail_new tr>td>a:focus {
		background: #92a4f3 !important;
	}


	/* 翻页样式 */
	.pre_page {
		width: 100%;
		margin-top: 5px;
		/* padding-bottom: 5px; */
	}

	.pre_page>ul {
		text-align: right;
		list-style: none;
	}

	.pre_page>ul>li>label {
		width: 24px;
		min-width: 24px;
	}

	.pre_page>ul>li>input {
		width: 48px;
		min-width: 48px;
	}

	.pre_page>ul>li>a {
		text-decoration: none;
	}

	.pre_page>ul>li>.go {
		display: inline-block;
		width: 30px;
		height: 20px;
		border: 1px solid #cccccc;
		background: #024aee;
		color: #fff;
		border-radius: 4px;
		text-align: center;
		margin-left: 5px;
	}

	.pre_page>ul>li>a:hover {
		color: #394656;
	}


	.pre_tan_conten {
		position: fixed;
		width: 80%;
		height: auto;
		left: 10%;
		top: 8%;
		/* background: #faf5f5; */
		background-color: azure;
		border-radius: 5px;
		max-height: 80%;
		z-index: 10;
		overflow-y: auto;
		overflow-x: hidden;

	}

	.content_edit_item label {
		min-width: 96px;
	}

	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.dlast-two-none>td:nth-last-child(4),
	.dlast-two-none>td:nth-last-child(3) {
		display: none;
	}
</style>


<!--
单条业务15个字段内用此模板
名称：通用基础模板2.0
日期：2021-01-02
作者：hj
目标：
方法 传入参数，
1、主界面固定按钮:查询、新建、备注说明,权限控制 导入和导出
2、弹窗编辑界面:通过权限控制 查询、增加、删除、修改、提交、导入、导出。、文件操作。
3、通过sel 来确定 查询标签。通过bold 来确定 必填项。
4、弹窗界面 一次性完成 主单据+明细单据保存。
5、主单据功能: 分页查询+通用编辑+table 可以换行
    明细功能: 单页查询+通用编辑方法+文件
6、隐藏首列ID,固定隐藏明细部分倒数第2、3列、为需要传值但是又不能显示出来的预留

2021-05-22 更新:
1、约定隐藏倒数2列，用与传递隐藏数据
2、选择参数结构
            {
              "name": "申请单",
              "val": "",
              "key": "val",
              "type": "text",
              "class": "long2",
              "list": t_list_department.data,
              "sel_val": {},
              "sel_name": "",
              "sel": "1"
            }
3、解除 父页面与子页面 因为 select 下拉菜单 导致的部分耦合。通过直接传入 list + 异步

参数结构 优化更新:

this.init_data = JSON.stringify({
          "title": '运输费用申请',
          "control": "transapply",
          "sel_action": 'exp_tr_apply',
          "upd_action": 'tr_apply',
          "d_sel_action": 'exp_tr2_apply',
          "d_upd_action": 'tr2_apply',
          "file_action": 'tr2_apply',
          "p1": 'bdwl',
          "p2": 'buy',
          "p3": '',
          "parm_sel": [
          ],
          "parm": [
          ],
          "parm_th": [
          ],
          "d_parm": [
            {
              "name_in": "收入费用名称",
              "name_out": "支出费用名称",
              "val": "",
              "key": "f_name",
              "type": "switch",
              "list_in": t_list_in.data,
              "sel_val_in": {},
              "list_out": t_list_out.data,
              "sel_val_out": {},
              "sel_name": "",
              "class": "long1",
              "p": "1"
            },
            {
              "name": "支出|收入",
              "val": "",
              "key": "io",  //必须是 io 关键字
              "type": "none",
              "class": "long1",
              "p": "1"
            },
          ],
          "d_name": [

          ]
        });


2021-05-29 更新:
1、弹出编辑框。编辑数据更新后，不能影响默认的查询条件下查询的数据，除非手动来修改。
2、

        -->
